// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"ec5467f7","594":"c0712774"}[chunkId] + ".chunk.css";
};